import React from 'react'
import { NumberField } from 'react-admin'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const FoodUpsellingList: React.FC<CatalogItemBaseListProps> = (props) => (
  <CatalogItemBaseList {...props}>
    <NumberField
      source="component.defaultCost"
      label="form.fields.defaultCost"
      sortable={false}
    />
  </CatalogItemBaseList>
)

export default FoodUpsellingList
